import React from "react";

import WarningImage from "@common/assets/images/warning.png";
import Button from "@common/components/Button/Button";
import { HelperText } from "@common/components/HelperText/HelperText";
import { ModalProps } from "@common/components/Modal/Modal";
import { ModalHeaderProps } from "@common/components/Modal/ModalHeader/ModalHeader";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

interface Props {
  Modal: React.ForwardRefExoticComponent<ModalProps & ModalHeaderProps & React.RefAttributes<unknown>>;
  internalProps?: ModalProps;
}

export default function DisconnectSentryModalBody({ Modal, internalProps }: Props) {
  return (
    <Modal
      {...internalProps}
      heading={"Now visit Sentry and disconnect Shake"}
      buttonText={"Skip, I don’t care"}
      buttonElement={
        <Button
          type="button"
          size="small"
          onClick={() => {
            window.open("https://sentry.io", "_blank")?.focus();
            internalProps?.setActive?.(false);
          }}
        >
          {"Open Sentry in new tab"}
        </Button>
      }
    >
      <Flex $column>
        <img
          style={{ alignSelf: "center", marginBottom: "2.4rem" }}
          src={WarningImage}
          alt="Warning"
        />
        <HelperText marginBottom={24}>
          {
            "To fully disconnect, you also need to remove Shake from your Sentry settings — otherwise you won't be able to reconnect later."
          }
        </HelperText>
        <Flex
          $column
          $gap={0.4}
        >
          <Paragraph>
            Visit <span style={{ color: vars.colors.grey30 }}>Sentry</span>
          </Paragraph>
          <Flex $gap={0.8}>
            <span style={{ color: vars.colors.grape }}>→</span>
            <Paragraph>Go to Settings</Paragraph>
          </Flex>
          <Flex $gap={0.8}>
            <span style={{ color: vars.colors.grape }}>→</span>
            <Paragraph>Integrations</Paragraph>
          </Flex>
          <Flex $gap={0.8}>
            <span style={{ color: vars.colors.grape }}>→</span>
            <Paragraph>Find Shake</Paragraph>
          </Flex>
          <Flex $gap={0.8}>
            <span style={{ color: vars.colors.grape }}>→</span>
            <Paragraph>Uninstall.</Paragraph>
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
}
